import {Dropdown} from "bootstrap";
import sal from 'sal.js'
import 'sal.js/dist/sal.css';

sal();

if (window.matchMedia('(max-width: 767px)').matches) {
    const collapse = document.getElementById('navbarSupportedContent')
    collapse.addEventListener('show.bs.collapse', function () {
        [].slice.call(document.querySelectorAll('.dropdown-toggle')).map(function (el) {
            return Dropdown.getOrCreateInstance(el).show();
        })
    })
}

document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
        window.location.href = this.getAttribute('href')
        return false
    })
});

document.querySelectorAll('.js_h').forEach(jsh => {
    ['mouseenter', 'touchstart'].forEach(event => {
        jsh.addEventListener(event, () => {
            jsh.classList.add('hover');
        })
    });
    ['mouseleave', 'touchend'].forEach(event => {
        jsh.addEventListener(event, () => {
            jsh.classList.remove('hover');
        })
    });
});

const yearSelect = document.getElementById('selector-archive-fiscal-year');
if (yearSelect != null) {
    yearSelect.addEventListener('change', function () {
        window.location.href = this.value;
    }, false);
}

document.querySelector('#page-top').addEventListener('click', () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});

